/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateScriptStepRequest
 */
export interface CreateScriptStepRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateScriptStepRequest
     */
    heading?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptStepRequest
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateScriptStepRequest
     */
    order?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateScriptStepRequest
     */
    fieldIds?: Array<number>;
}

/**
 * Check if a given object implements the CreateScriptStepRequest interface.
 */
export function instanceOfCreateScriptStepRequest(value: object): boolean {
    return true;
}

export function CreateScriptStepRequestFromJSON(json: any): CreateScriptStepRequest {
    return CreateScriptStepRequestFromJSONTyped(json, false);
}

export function CreateScriptStepRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScriptStepRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'heading': json['heading'] == null ? undefined : json['heading'],
        'content': json['content'] == null ? undefined : json['content'],
        'order': json['order'] == null ? undefined : json['order'],
        'fieldIds': json['fieldIds'] == null ? undefined : json['fieldIds'],
    };
}

export function CreateScriptStepRequestToJSON(value?: CreateScriptStepRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'heading': value['heading'],
        'content': value['content'],
        'order': value['order'],
        'fieldIds': value['fieldIds'],
    };
}

